import { Chart } from "react-google-charts";
import { useEffect, useState } from 'react'
import { Text, LoadComponent } from ".."
import api from "../../../services/api";
import { useApp } from "../../../contexts";
import { translateText } from "../../../helpers/util";

export const PieChartOccupation = ({ title = "", officeId }) => {
    const [occupationProfile, setOccupationProfile] = useState([])
    const [load, setLoad] = useState(false)
    const { language, translations, userCountry } = useApp();
    useEffect(() => {
        setLoad(true)
        api.get(`/office/${officeId}/occupationprofile`).then(response=>{
            const { occupationProfile } = response.data;
            setOccupationProfile(occupationProfile)
        }).catch((error) => {
            console.log(error)
        }).finally(()=>{
            setLoad(false)
        })

    }, []); 

    let data = [ 
        [ translateText("Segmento", language, translations, userCountry), translateText("Porcentagem", language, translations, userCountry)] 
    ];
    
    occupationProfile.forEach( profile => {
        const result = [];

        result.push(translateText(profile.segment, language, translations, userCountry));
        result.push(parseFloat(profile.perc));

        data.push( result);
    })
    const options = {
        title: title,
        pieSliceText: "none",
        legend: { position: 'left' },
        chartArea: { 
            width: '100%', height: '80%'
        },
        
    };

    return (
        <>
            <LoadComponent isLoading={load}>
                <Text style={styles.title}>{translateText("Perfil de Ocupação", language, translations, userCountry)}</Text>
                <Chart
                chartType="PieChart"
                data={data}
                options={options}
                width={"100%"}
                height={"100%"}
                />
            </LoadComponent>
        </>
    )
}

const styles = {
    title: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#7a7b7c"
    }
}